module.exports = __webpack_public_path__ + "img/banner-01.e9c2026d.jpg";